module.exports = __webpack_public_path__ + "assets/img/ku_icon02.f8ab63ed.png";